
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 363 363"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M347.62 93.694c-.749-26.239-16.011-54.575-40.502-63.519V7.5a7.5 7.5 0 0 0-7.5-7.5h-236a7.5 7.5 0 0 0-7.5 7.5v23.108c-9.19 3.602-17.647 9.993-24.618 18.791-9.794 12.362-15.67 28.507-16.12 44.295-.677 23.716 10.612 45.18 30.198 57.416 8.875 5.544 18.625 8.763 28.54 9.649V355.5a7.5 7.5 0 0 0 7.5 7.5h200a7.5 7.5 0 0 0 7.5-7.5V160.738c9.833-.916 19.501-4.129 28.304-9.628 19.586-12.236 30.875-33.7 30.198-57.416zM71.118 15h221v12h-221V15zm66.923 99h86.918c1.707 15.476 11.077 29.399 25.545 38H112.496c14.468-8.601 23.838-22.524 25.545-38zm-48.923 53h35v181h-35V167zm50 0h35v181h-35V167zm50 0h35v181h-35V167zm50 0h35v181h-35V167zm70.356-28.611c-15.086 9.425-33.48 10.136-49.2 1.901-11.979-6.274-19.656-17.14-20.537-29.063-.758-10.254 3.494-19.551 11.664-25.508 7.274-5.304 17.997-6.138 26.075-2.031 4.406 2.24 9.659 6.764 9.659 15.592a7.5 7.5 0 0 0 7.5 7.5 7.5 7.5 0 0 0 7.5-7.5c0-12.636-6.51-23.192-17.861-28.963-13.113-6.668-29.875-5.348-41.711 3.282a43.36 43.36 0 0 0-16.767 25.402h-88.592a43.351 43.351 0 0 0-16.767-25.402c-11.834-8.629-28.599-9.95-41.711-3.282-11.352 5.771-17.861 16.328-17.861 28.963a7.5 7.5 0 0 0 15 0c0-8.828 5.253-13.352 9.659-15.592 8.076-4.108 18.8-3.274 26.075 2.031 8.17 5.957 12.422 15.255 11.664 25.508-.881 11.924-8.559 22.789-20.537 29.063-15.721 8.234-34.113 7.524-49.2-1.901-15.245-9.523-23.684-25.658-23.152-44.267.76-26.652 19.57-50.332 41.114-51.815h218.53c.303 0 .6-.023.893-.058.241.029.486.049.734.055 10.668.266 20.787 5.93 28.495 15.95 7.565 9.833 12.115 22.907 12.485 35.867.532 18.609-7.906 34.744-23.151 44.268z"}})])
          )
        }
      }
    